// GC Coach knowledge domains — the closed enum of 8 substantive areas the
// coaching content is organized around. Source: design/data-model-v0.md § 3.4
// (line 138: `D1_strategy_org · D2_external_counsel · D5_kpis_performance`
// active for MVP; D3/D4/D6/D7/D8 reserved for V1+ content authoring).
//
// All KB entries carry a domain. Most retrieval flows pre-filter by domain.
// The 8 codes are stable identifiers; human-readable labels live in admin i18n
// (frontend) — backend never displays domain names, only routes by code.

export type Domain =
  | 'D1_strategy_org'
  | 'D2_external_counsel'
  | 'D3_legal_ops_tech'
  | 'D4_team_dev'
  | 'D5_kpis_performance'
  | 'D6_budget_finance'
  | 'D7_stakeholder_comms'
  | 'D8_governance_risk';

export const ALL_DOMAINS: ReadonlyArray<Domain> = [
  'D1_strategy_org',
  'D2_external_counsel',
  'D3_legal_ops_tech',
  'D4_team_dev',
  'D5_kpis_performance',
  'D6_budget_finance',
  'D7_stakeholder_comms',
  'D8_governance_risk',
] as const;

/**
 * Domains with content actively authored in MVP. Per Olivier's call: D1, D2,
 * D5 first. D3/D4/D6/D7/D8 content lands in V1+ (schema supports them today,
 * just no entries yet).
 */
export const MVP_ACTIVE_DOMAINS: ReadonlyArray<Domain> = [
  'D1_strategy_org',
  'D2_external_counsel',
  'D5_kpis_performance',
] as const;

export function isDomain(value: unknown): value is Domain {
  return typeof value === 'string' && (ALL_DOMAINS as ReadonlyArray<string>).includes(value);
}
